export const GET_STAGES = "GET_STAGES";
export const GET_STAGE_BY_ID = "GET_STAGE_BY_ID";
export const UPDATE_STAGE = "UPDATE_STAGE";
export const DELETE_STAGE = "DELETE_STAGE";
export const CREATE_STAGE = "CREATE_STAGE";
